<template>
  <div v-show="show" class="v-fade book-export__copy-notification">
    <div>Copied</div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()
</script>
